import React, {useEffect, useRef} from 'react'
import styled from 'styled-components'
import { init } from 'ityped';
import {useHistory} from 'react-router'
import {AiFillHome} from 'react-icons/ai'

function NotFound() {

    const history = useHistory()

    const textRef = useRef()

    useEffect(() => {
        init(textRef.current, {
            showCursor: true,
            typeSpeed:  40,
            backDelay: 300,
            loop: true,
            strings: ["Faqja që po kërkoni nuk ekziston", "Questa Pagina Non Esiste!", "This Page Does Not Exist!"]
        })
    }, [])

    const handleBack = () => {
        history.push('/');
    }



    return (
        <Container>
            <h1>Oopss...</h1>
            <div>
            <span ref={textRef}></span>
            </div>
            <CustomIcon onClick={handleBack} />
        </Container>
    )
}

export default NotFound


const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h1 {
        color: #fff;
        font-size: 45px;
    }

    span {
        height: 50px;
        color: #fff;
        font-size: 18px;
    }
`

const CustomIcon = styled(AiFillHome)`
    cursor: pointer;
    font-size: 20px;
    margin-top: 50px;
    background-color: #fff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    padding: 10px;
    transition: all .5s ease;

    &:hover {
        transform: scale(1.06);
        box-shadow: 5px 5px 15px rgba(0,0,0,0.5);
    }
`